import { CustomFormattedMessage } from '../../../../i18n/i18n';
import { AmountRows } from './AmountRows';
import { Transaction, weaklyDisplayMonetaryAmounts } from '../../../../models';

type CompletedAmountsOverviewProps = {
  transaction: Transaction;
};

export const CompletedAmountsOverview = ({
  transaction,
}: CompletedAmountsOverviewProps) => {
  return (
    <>
      {transaction.completionAmount && (
        <>
          <h6 className="padding-left-10 margin-top-20">
            <CustomFormattedMessage id="common.transaction.invoiced" />
          </h6>
          <table className="table table-condensed">
            <colgroup>
              <col className="width-150" />
              <col />
            </colgroup>
            <tbody>
              <AmountRows
                netLabel={'common.transaction.totalPriceNet'}
                grossLabel={'common.transaction.totalPriceGross'}
                amount={transaction.completionAmount}
                weaklyDisplayAmounts={weaklyDisplayMonetaryAmounts(
                  transaction.state,
                )}
                highlightLabel
              />
            </tbody>
          </table>
        </>
      )}
    </>
  );
};
